import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { WorkingHourDay } from './WorkingHourDay';
import { Day, weekDays } from './weekDays';

@Component({
  selector: 'cc-lg-days-range',
  templateUrl: './days-range.component.html',
  styleUrls: ['./days-range.component.scss']
})
export class DaysRangeComponent implements OnInit, OnChanges {
  @Input() selectedDays: number[];
  @Input() disabledDays: number[];
  @Input() isNotValid: boolean;
  @Output() selectedDay = new EventEmitter<number>();

  days: WorkingHourDay[];

  constructor() {}

  ngOnInit() {
    this.resetDays();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.resetDays();
  }

  changeSelection(day: WorkingHourDay) {
    if (day.disabled) {
      return;
    }
    const selectedDay = this.days.find(d => d.label === day.label);
    selectedDay.selected = !selectedDay.selected;
    this.selectedDay.emit(day.dayNumber);
  }

  private resetDays() {
    this.days = weekDays.map((day: Day) => {
      const isSelected = this.selectedDays.includes(day.number);
      const isDisabled = this.disabledDays.includes(day.number);
      return {
        label: day.label,
        dayNumber: day.number,
        selected: isSelected,
        disabled: !isSelected && isDisabled
      };
    });
  }
}
